module.exports = __webpack_public_path__ + "img/720.6b15d6e3.svg";